module.exports = __webpack_public_path__ + "static/review_hammer-b4592f78d55f80685d8efb8d080f9f09.png";